import { createRootRoute, Outlet } from '@tanstack/react-router';

import { HighlightStyleManager } from '@/components/providers/hljs-style';
import { ThemeProvider } from '@/components/providers/theme-provider';
import { Toaster } from '@/components/ui/sonner';
import { BUDDY_TOASTER_ID } from '@/lib/onboarding/toasts';

/**
 * Root route: theme, code-highlighting stylesheet + toaster shell around the router outlet. i18n
 * (`AppIntlProvider`) wraps the whole `RouterProvider` in `main.tsx`. The
 * auth/session providers live in a nested layout so public routes can skip
 * them (former `ConditionalProviders` split).
 */
export const Route = createRootRoute({
  component: RootComponent,
});

function RootComponent() {
  return (
    <ThemeProvider
      attribute="class"
      defaultTheme="system"
      enableSystem
      disableTransitionOnChange
      storageKey="octopus-theme"
    >
      {/* Code-block colours: the public chat widget highlights code too. */}
      <HighlightStyleManager />
      <Outlet />
      {/* Before the common list: a short plain toast lies over the buddy's, which stays. */}
      <Toaster id={BUDDY_TOASTER_ID} position="top-center" />
      <Toaster richColors position="top-center" closeButton />
    </ThemeProvider>
  );
}
